module.exports = __webpack_public_path__ + "img/ry_banner_hk.85e47beb.png";